// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Layout from "./components/layout/layout";
import router from "./router/index";
import store from "./store/";
import Vuex from 'vuex'
import Ajax from "vue-resource";
import Toast from "./assets/js/toast";
import Loading from "./assets/js/loading";
import iView from "iview";
import "iview/dist/styles/iview.css";
import fastClick from 'fastclick'
import VueQrcodeReader from "vue-qrcode-reader";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import zhLocale from "iview/src/locale/lang/zh-CN";
import enLocale from "iview/src/locale/lang/en-US";
//多语言
//import i18n from './lang'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载

Vue.use(Vuex)
Vue.use(VueQrcodeReader);
fastClick.attach(document.body)
Vue.use(Ajax);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(ElementUI);

Vue.http.options.emulateJSON = true;
Vue.config.productionTip = false;


// const i18n = new VueI18n({
//   locale: lang,    // 语言标识
//   //this.$i18n.locale // 通过切换locale的值来实现语言切换
//   messages: {
//     'zh-CN': Object.assign(require('./lang/zh-CN.js'),zhLocale),   // 中文语言包
//     'en-US': Object.assign(require('./lang/en-US.js'),enLocale)    // 英文语言包
//   }
// })

//携带JSESSIONID， by binfeng, 不要删除
Vue.http.interceptors.push((request, next)  =>{
  let sid = window.sessionStorage.getItem('JSESSIONID');
  if(sid){
    request.headers.set('JSESSIONID',sid);
  }
  next((response) => {
    if (response.status == 440 || response.status == 504) {
      window.location.href = "/login";
    }
    return response;
  });
});

(function(){
  let that = this;
  let url = '/api/sysconfig/getValue?key=WeMeetLanguage';
  let data = {key:'WeMeetLanguage'};
  let wmLang = "zh-CN";             //缺省中文

  fetch(url, {
    method: 'get'
  }).then(e => e.json())
  .then(function(res) {
    if(res.status==2000 && res.data.value && res.data.value.indexOf("en") >= 0){
      wmLang = "en-US"; //配置成了英文
    }
    // wmLang = "en-US";
    const i18n = new VueI18n({
      locale: wmLang,    // 语言标识
      //this.$i18n.locale // 通过切换locale的值来实现语言切换
      messages: {
        'zh-CN': Object.assign(require('./lang/zh-CN.js'),zhLocale),   // 中文语言包
        'en-US': Object.assign(require('./lang/en-US.js'),enLocale)    // 英文语言包
      }
    })

    Vue.use(iView, {
      i18n: (key, value) => i18n.t(key, value)
    });

    new Vue({
      el: "#app",
      router,
      store,
      i18n,
      render: h => h(Layout)
    });

    Vue.prototype.$Message.config({
      top: 60,
      duration: 3
    });
  })  
})()



fastClick.prototype.focus = function (targetElement) {

  var length;

  // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.

  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {

    length = targetElement.value.length;

    targetElement.focus();

    targetElement.setSelectionRange(length, length);

  } else {

    targetElement.focus();

  }

};
// fastClick.prototype.onTouchEnd = function (event) {
//   var foriView, trankingClickeStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
//   var targetClass = event.target.className.split(' ')
//   if (targetClass.indexOf['ivu-upload-input'] !== -1 || targetClass.indexOf['ivu-upload'] !== -1){
//     return false;
//   }
//   if (!this.trankingClick) {
//     return true;
//   }
// };




// WEBPACK FOOTER //
// ./src/main.js